import { Injectable } from '@angular/core';
import type { ClientDeleteQueryInterface } from '@zaoblako/shared/modules/client/dtos/client/client-delete-query.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { ClientsListPageInterface } from '@zaoblako/shared/modules/client/dtos/client/clients-list-page.dto';
import type { ClientsListQueryInterface } from '@zaoblako/shared/modules/client/dtos/client/clients-list-query.dto';
import type { ClientBrsTasksWidgetFindInterface } from '@zaoblako/shared/modules/client/dtos/client/widgets/client-brs-tasks-widget-find.dto';
import type { ClientDealsWidgetFindInterface } from '@zaoblako/shared/modules/client/dtos/client/widgets/client-deals-widget-find.dto';
import type { ClientDealsWidgetQueryInterface } from '@zaoblako/shared/modules/client/dtos/client/widgets/client-deals-widget-query.dto';
import type { ClientDocumentsWidgetFindInterface } from '@zaoblako/shared/modules/client/dtos/client/widgets/client-documents-widget-find.dto';
import type { ClientDocumentsWidgetQueryInterface } from '@zaoblako/shared/modules/client/dtos/client/widgets/client-documents-widget-query.dto';
import type { ClientHelpdeskTasksWidgetFindInterface } from '@zaoblako/shared/modules/client/dtos/client/widgets/client-helpdesk-tasks-widget-find.dto';
import type { ClientHelpdeskTasksWidgetQueryInterface } from '@zaoblako/shared/modules/client/dtos/client/widgets/client-helpdesk-tasks-widget-query.dto';
import type { ClientProjectsWidgetFindInterface } from '@zaoblako/shared/modules/client/dtos/client/widgets/client-projects-widget-find.dto';
import type { ClientProjectsWidgetQueryInterface } from '@zaoblako/shared/modules/client/dtos/client/widgets/client-projects-widget-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientService extends BaseService {
  public baseUrl = '/basis/client/client';

  public findWithPagination(queryParams: ClientsListQueryInterface): Observable<ClientsListPageInterface> {
    return this.http.get<ClientsListPageInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }

  public findAll(queryParams?: ClientsListQueryInterface): Observable<ClientFindInterface[]> {
    return this.http.get<ClientFindInterface[]>(`${this.baseUrl}/all`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getDocuments(
    clientId: number,
    queryParams: ClientDocumentsWidgetQueryInterface
  ): Observable<ClientDocumentsWidgetFindInterface> {
    return this.http.get<ClientDocumentsWidgetFindInterface>(`${this.baseUrl}/${clientId}/documents`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getDeals(clientId: number, queryParams: ClientDealsWidgetQueryInterface): Observable<ClientDealsWidgetFindInterface> {
    return this.http.get<ClientDealsWidgetFindInterface>(`${this.baseUrl}/${clientId}/deals`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getProjects(
    clientId: number,
    queryParams: ClientProjectsWidgetQueryInterface
  ): Observable<ClientProjectsWidgetFindInterface> {
    return this.http.get<ClientProjectsWidgetFindInterface>(`${this.baseUrl}/${clientId}/projects`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getHelpdeskTasks(
    clientId: number,
    queryParams: ClientHelpdeskTasksWidgetQueryInterface
  ): Observable<ClientHelpdeskTasksWidgetFindInterface> {
    return this.http.get<ClientHelpdeskTasksWidgetFindInterface>(`${this.baseUrl}/${clientId}/helpdesk-tasks`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getTasks(clientId: number): Observable<ClientBrsTasksWidgetFindInterface> {
    return this.http.get<ClientBrsTasksWidgetFindInterface>(`${this.baseUrl}/${clientId}/brs-tasks`);
  }

  public deleteClient(id: number, queryParams?: ClientDeleteQueryInterface): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`, { params: this.objectToHttpParams(queryParams) });
  }
}
